import { doApiCall } from "./v3/utils";
import axios from "axios";
import { getSpouseEligibility } from "./spouseApi";
import { getExistingKitOrders } from "./ordersApi";
import { getRiskAssessment, getTestKitIdForEachTestType } from "./v3/orderApi";
import { getSurveyJson } from "./v3/surveyApi";
import { getMemberData } from "./membersApi";
import {
  getUserAgreementHtml,
  getUserAgreementVersionAcceptanceStates
} from "./termsAndConditionsApi";
const {
  REACT_APP_MEMBER_PORTAL_ENDPOINT_URL,
  REACT_APP_REGISTRATION_API_URL
} = process.env;

/**
 *
 * @param {*} email
 * @returns true or false
 * @description This verify if this is or not a valid member email
 */
export const verifyEmail = (email) => {
  const payload = {
    email: email
  };
  const request = {
    host: `${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}`,
    method: "POST",
    url: `https://${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}/password-reset`,
    data: payload,
    body: JSON.stringify(payload)
  };

  return doApiCall(request);
};

export const updateEmail = (email) => {
  const payload = {
    data: {
      email
    }
  };
  const request = {
    host: `${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}`,
    method: "PATCH",
    url: `https://${REACT_APP_REGISTRATION_API_URL}/user`,
    data: payload,
    body: JSON.stringify(payload)
  };

  return doApiCall(request);
};

export const testAccessCode = (accessCode, userName, auth0UserId) => {
  const payload = {
    accessCode: accessCode,
    userName: userName,
    userId: auth0UserId
  };
  const request = {
    host: `${REACT_APP_REGISTRATION_API_URL}`,
    method: "POST",
    url: `https://${REACT_APP_REGISTRATION_API_URL}/registration`,
    data: payload,
    body: JSON.stringify(payload)
  };

  return doApiCall(request);
};

/**
 *
 * @param {*} email
 * @returns
 * @decription this returns a new email into the user inbox to reset their password
 */
export const forgotPassword = (email) => {
  const payload = {
    email: email
  };

  const request = {
    host: `${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}`,
    method: "POST",
    url: `https://${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}/password-reset`,
    data: payload,
    body: JSON.stringify(payload)
  };

  return doApiCall(request);
};

/**
 *
 * @param {*} payload
 * @returns
 */
export const validateAccount = (payload) => {
  const request = {
    host: `${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}`,
    method: "POST",
    url: `https://${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}/validate-account`,
    data: payload,
    body: JSON.stringify(payload)
  };

  return doApiCall(request);
};

/**
 * @description Get all the data in a parallel when logging in
 */
export const doGreatInitialApiScrape = () => {
  return axios
    .all([
      getMemberData(),
      getUserAgreementVersionAcceptanceStates(),
      getUserAgreementHtml(),
      getSpouseEligibility(),
      getExistingKitOrders(),
      getTestKitIdForEachTestType(),
      getSurveyJson("precision-guidance-survey"),
      getRiskAssessment()
    ])
    .then(
      axios.spread(
        (
          memberDataResponse,
          userAgreementVersionAcceptanceResponse,
          userAgreementHtmlResponse,
          spouseResponse,
          existingKitOrdersResponse,
          testKitIdForEachTestTypeResponse,
          gettingStartedSurveyResponse,
          riskAssessmentResponse
        ) => {
          return [
            memberDataResponse,
            userAgreementVersionAcceptanceResponse,
            userAgreementHtmlResponse,
            spouseResponse,
            existingKitOrdersResponse,
            testKitIdForEachTestTypeResponse,
            gettingStartedSurveyResponse,
            riskAssessmentResponse
          ];
        }
      )
    );
};
